<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2021-07-12 17:03:33
 * @LastEditors: xiawenlong
 * @LastEditTime: 2026-02-28 09:15:00
-->
<template>
  <div id="app">
    <router-view />
    <DashboardLoginDialog ref="LoginDialog" />
  </div>
</template>

<script>
import DashboardLoginDialog from '@/components/common/DashboardLoginDialog'
import { onTokenInvalid, registerLoginEnsure } from '@/utils/dashboard-auth'
export default {
  name: 'App',
  components: { DashboardLoginDialog },
  mounted() {
    // 注册点弹窗时的登录校验入口
    registerLoginEnsure(() => this.$refs.LoginDialog.ensure())
    // 运行中任意接口返回 987989 时统一弹出登录
    this.unbindTokenInvalid = onTokenInvalid(() => this.$refs.LoginDialog.show())
  },
  beforeDestroy() {
    this.unbindTokenInvalid && this.unbindTokenInvalid()
  },
}
</script>
<style lang="scss" scoped>
#app {
  font-family: Noto Sans SC, 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}
</style>
